import { SmsCampaignStep } from './SmsCampaignValidation';

const STEP_VALIDATION_ERROR_MESSAGE = 'Please resolve validation errors before continuing.';
const STEP_IDS_WITH_INLINE_VALIDATION_MESSAGE: ReadonlySet<SmsCampaignStep> = new Set([
  'TitleDescription',
  'AudienceSelection',
  'PreviewSchedule',
]);

type GuardedStepTransitionArgs = {
  stepId: SmsCampaignStep;
  validate: () => Promise<boolean>;
  onValid: () => void;
  setStepError: (value: string | null) => void;
};

export const runGuardedSmsStepTransition = async ({
  stepId,
  validate,
  onValid,
  setStepError,
}: GuardedStepTransitionArgs): Promise<boolean> => {
  setStepError(null);
  const isValid = await validate();
  if (!isValid) {
    if (STEP_IDS_WITH_INLINE_VALIDATION_MESSAGE.has(stepId)) {
      setStepError(STEP_VALIDATION_ERROR_MESSAGE);
    }
    return false;
  }

  onValid();
  return true;
};
